import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import SelectBanco from 'app/components/Select/SelectBanco';
import configuracaoBanco from 'app/utils/configuracaoBanco';
import PropTypes from 'prop-types';
import React from 'react';

const ContaBancariaForm = ({
  handleChange,
  onBlur,
  errors,
  contaDescricao,
  readOnly,
  contaBancaria,
  touched,
  required = true,
}) => {
  if (contaBancaria === null) {
    contaBancaria = {};
  }

  const { tipoConta, banco, agencia, contaDigito, numeroConta, agenciaDigito } = contaBancaria;

  const onlyNumberRegex = /^\d*$/;

  const alphaNumericRegex = /^[a-z0-9]+$/i;

  const codigoBanco = banco?.codigo;
  const maxLengthAgencia = configuracaoBanco.get(codigoBanco)?.agencia || configuracaoBanco.get('global')?.agencia;
  const maxLengthConta = configuracaoBanco.get(codigoBanco)?.conta || configuracaoBanco.get('global')?.conta;

  /*
   * RNE-060 - Limite de dígitos para "Agência" e "Conta" :
   * O sistema deve exibir inicialmente os campos "Agência" e "Conta" desabilitados até que o campo "Banco" seja informado.
   * Observação: Caso o usuário altere ou limpe o banco após ter informado os campos, o sistema deve limpá-los.
   */
  const desabilitarAgenciaConta = !banco;

  const handleChangeBanco = (event) => {
    handleChange(event);

    handleChange({ target: { id: 'pessoa.conta.contaBancaria.agencia', value: '' } });
    handleChange({ target: { id: 'pessoa.conta.contaBancaria.agenciaDigito', value: '' } });
    handleChange({ target: { id: 'pessoa.conta.contaBancaria.numeroConta', value: '' } });
    handleChange({ target: { id: 'pessoa.conta.contaBancaria.contaDigito', value: '' } });
  };

  return (
    <>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextInput
          readOnly={readOnly}
          fullWidth
          autoFocus
          id="pessoa.conta.descricao"
          label="Descrição"
          onChange={handleChange}
          onBlur={onBlur}
          value={contaDescricao}
          maxLength={30}
          error={errors?.pessoa?.conta?.descricao}
          touched={touched?.pessoa?.conta?.descricao}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectInput
          readOnly={readOnly}
          id="pessoa.conta.contaBancaria.tipoConta"
          label="Tipo da conta"
          onChange={handleChange}
          onBlur={onBlur}
          value={tipoConta}
          error={errors?.pessoa?.conta?.tipoConta}
          required={!!errors?.pessoa?.conta?.tipoConta}
          touched={!!errors?.pessoa?.conta?.tipoConta}
          options={[
            { id: 'CORRENTE', title: 'Conta corrente' },
            { id: 'POUPANCA', title: 'Conta poupança' },
            { id: 'INVESTIMENTO', title: 'Conta investimento' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectBanco
          id="pessoa.conta.contaBancaria.banco"
          name="pessoa.conta.contaBancaria.banco"
          label="Banco"
          onChange={handleChangeBanco}
          onBlur={onBlur}
          value={!!banco && Object.keys(banco).length ? banco : null}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          readOnly={readOnly}
          id="pessoa.conta.contaBancaria.agencia"
          fullWidth
          label="Agência"
          onChange={handleChange}
          pattern={onlyNumberRegex}
          onBlur={onBlur}
          value={agencia}
          maxLength={maxLengthAgencia}
          disabled={desabilitarAgenciaConta}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <TextInput
          readOnly={readOnly}
          fullWidth
          id="pessoa.conta.contaBancaria.agenciaDigito"
          label="Dígito"
          onChange={handleChange}
          onBlur={onBlur}
          value={agenciaDigito}
          pattern={alphaNumericRegex}
          maxLength={1}
          disabled={desabilitarAgenciaConta}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextInput
          readOnly={readOnly}
          id="pessoa.conta.contaBancaria.numeroConta"
          fullWidth
          label="Conta"
          onChange={handleChange}
          pattern={onlyNumberRegex}
          onBlur={onBlur}
          value={numeroConta}
          maxLength={maxLengthConta}
          disabled={desabilitarAgenciaConta}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <TextInput
          readOnly={readOnly}
          id="pessoa.conta.contaBancaria.contaDigito"
          fullWidth
          label="Dígito"
          onChange={handleChange}
          onBlur={onBlur}
          value={contaDigito}
          pattern={alphaNumericRegex}
          maxLength={1}
          disabled={desabilitarAgenciaConta}
        />
      </Grid>
    </>
  );
};

ContaBancariaForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  contaDescricao: PropTypes.string,
  readOnly: PropTypes.bool,
  contaBancaria: PropTypes.shape({
    tipoConta: PropTypes.string,
    banco: PropTypes.object,
    agencia: PropTypes.string,
    agenciaDigito: PropTypes.string,
    numeroConta: PropTypes.string,
    contaDigito: PropTypes.string,
  }),
};

ContaBancariaForm.defaultProps = {
  contaBancaria: {},
};

export default ContaBancariaForm;
